import React from 'react';
import { accountService, basicService } from '@app/services';
import { SetUsername, SetResetPasswordError, SetLoginForm } from '@app/models';
import { loginForms } from '@app/enums';

export const returnToLogin = (setLoginForm?: SetLoginForm) => () => {
    setLoginForm ? setLoginForm(loginForms.unknown) : basicService.redirect('/signin');
};

export const onChangeUsername = (setUsername: SetUsername, inputRef: any) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(e.target.value);
    if (inputRef && inputRef.current) {
        inputRef.current.value = e.target.value;
    }
};

export const checkUserCanResetPassword = (
    username: string,
    setIsError: SetResetPasswordError,
    onSuccess: (res: Record<string, any>) => void,
    setIsLoading?: (is: boolean) => void
) => {
    return accountService.checkIsUserCanResetPassword(
        username,
        () => {
            setIsError({ isUsernameInvalid: true, isEmptyUsername: false });
            setIsLoading && setIsLoading(false);
        },
        onSuccess
    );
};

export const onSubmitUserCheck =
    (username: string, setIsError: SetResetPasswordError, onSuccess: (res: Record<string, any>) => void, setIsLoading?: (is: boolean) => void) =>
    (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (username !== undefined && username !== '') {
            setIsError({ isUsernameInvalid: false, isEmptyUsername: false });
            setIsLoading && setIsLoading(true);
            checkUserCanResetPassword(username, setIsError, onSuccess, setIsLoading);
        } else {
            setIsError({ isUsernameInvalid: false, isEmptyUsername: true });
        }
    };
